export const BLU_TRV_MIN_VALVE_MIN = 0;
export const BLU_TRV_MIN_VALVE_MAX = 99;

export const BLU_TRV_MIN_TARGET_C_MIN = 4;
export const BLU_TRV_MIN_TARGET_C_MAX = 29.9;
export const BLU_TRV_MAX_TARGET_C_MIN = 4.1;
export const BLU_TRV_MAX_TARGET_C_MAX = 30;

export const BLU_TRV_MAX_COMPENSATION_C_MIN = 0;
export const BLU_TRV_MAX_COMPENSATION_C_MAX = 5;

export type BluTrvConfigSlice = {
	min_valve_position?: number;
	min_target_C?: number;
	max_target_C?: number;
	max_compensation_C?: number;
};

export type BluTrvDirtyNumber = {
	dirty: boolean;
	value: number;
};

export function isBluTrvFiniteNumber(value: unknown): value is number {
	return typeof value === 'number' && Number.isFinite(value);
}

export function bluTrvHasMinValve(config: BluTrvConfigSlice | undefined): boolean {
	return isBluTrvFiniteNumber(config?.min_valve_position);
}

export function bluTrvHasTargetLimits(config: BluTrvConfigSlice | undefined): boolean {
	return isBluTrvFiniteNumber(config?.min_target_C) && isBluTrvFiniteNumber(config?.max_target_C);
}

export function bluTrvHasCompensation(config: BluTrvConfigSlice | undefined): boolean {
	return isBluTrvFiniteNumber(config?.max_compensation_C);
}

export function bluTrvTargetOrderIsValid(minTarget: number, maxTarget: number): boolean {
	return Number.isFinite(minTarget) && Number.isFinite(maxTarget) && minTarget < maxTarget;
}

export function buildBluTrvSetConfigSlice(
	fields: Partial<Record<keyof BluTrvConfigSlice, BluTrvDirtyNumber>>,
): Record<string, number> {
	const payload: Record<string, number> = {};

	(Object.keys(fields) as (keyof BluTrvConfigSlice)[]).forEach((key) => {
		const field = fields[key];
		if (field?.dirty && Number.isFinite(field.value)) {
			payload[key] = field.value;
		}
	});

	return payload;
}
